import { DELETE_COMMENT } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_COMMENT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_COMMENT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_COMMENT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
